// extracted by mini-css-extract-plugin
export default {"nav":"index_nav_SV8MS","item":"index_item_r5uZS","active":"index_active_kLf9G"};